module.exports = __webpack_public_path__ + "static/media/rose-buds-symmetric-floral-design-svgrepo-com.ad5ef3fb.svg";